
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/auth'
import 'firebase/compat/database'
import 'firebase/database'
import 'firebase/compat/storage'
import 'firebase/storage'

// const firebaseConfig = {
//   apiKey: "AIzaSyDt1D6usC_JE6BLoLU0dv9XXfbxakldKfY",
//   authDomain: "messenger-29b92.firebaseapp.com",
//   projectId: "messenger-29b92",
//   storageBucket: "messenger-29b92.appspot.com",
//   messagingSenderId: "1020073866840",
//   appId: "1:1020073866840:web:7c0df7e334ef2126c1bc2d"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyCnkDtgHroRJKSP-Ra5wOJdhz1uSpHLlWc",
//   authDomain: "chatly-3ffd8.firebaseapp.com",
//   projectId: "chatly-3ffd8",
//   storageBucket: "chatly-3ffd8.appspot.com",
//   messagingSenderId: "89491133135",
//   appId: "1:89491133135:web:ce0c656c9f816ced671dba"
// };

// latest from aswikrishna213

const firebaseConfig = {
  apiKey: "AIzaSyCyzJzTBeM5qxIoJ70a2DDHlV0DhLjeOgA",
  authDomain: "mess-b22d9.firebaseapp.com",
  projectId: "mess-b22d9",
  storageBucket: "mess-b22d9.appspot.com",
  messagingSenderId: "118681792657",
  appId: "1:118681792657:web:51f1a1f304c667db4dcf30"
};


export default firebase.initializeApp(firebaseConfig)